
export const root = {
    padding: '0.5rem 1rem',
    gap: '0.25rem',
    borderRadius: '0',
    background: 'transparent',
    color: '{content.color}',
    transitionDuration: '{transition.duration}'
};

export const navButton = {
    background: 'transparent',
    hoverBackground: '{surface.100}',
    selectedBackground: '{primary.color}',
    color: '{text.muted.color}',
    hoverColor: '{text.color}',
    selectedColor: '#ffffff',
    width: '1.75rem',
    height: '1.75rem',
    borderRadius: '50%',
    focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '{focus.ring.offset}',
        shadow: '{focus.ring.shadow}'
    }
};

export const currentPageReport = {
    color: '{text.muted.color}'
};

export const jumpToPageInput = {
    maxWidth: '2.5rem'
};

// Paginator font-size not tokenized by PrimeNG — override via css
export const css = ({dt}: {dt: (token: string) => string}) => `
.p-paginator {
    font-size: 0.75rem;
    justify-content: flex-end;
}
.p-paginator-current {
    margin-right: auto;
}
.p-paginator-page {
    font-size: 0.6875rem;
    font-weight: 500;
}
`;

export default {
    root,
    navButton,
    currentPageReport,
    jumpToPageInput,
    css
};
